// extracted by mini-css-extract-plugin
export var phone = "_4e-0";
export var phoneDragging = "_4e-1";